let Utils = require("../lib/Utils");

let Meter = function (props) {
  let {
    percent = 0,
    width = 100,
    height = 10,
    rounded = true,
    color = "#0078bc",
    animate = false,
    label
  } = props;

  let r = rounded ? Math.ceil(height / 2) : 0;
  let w = percent ? Math.max(height, width * Math.min(percent, 1)) : 0;

  let id = Utils.id();

  return (
    <svg className="mc-meter" width={width} height={height} aria-label={label} data-tooltip={label}>
      <defs>
        <clipPath id={id}>
          <rect width={width} height={height} rx={r} ry={r}/>
        </clipPath>
      </defs>
      <rect width={width} height={height} fill="#e4e4e4" rx={r} ry={r}/>
      <rect
        width={w}
        height={height}
        fill={color}
        rx={r}
        ry={r}
        data-animate={animate}
        clipPath={"url(#" + id + ")"}/>
    </svg>
  );
};

module.exports = Meter;